import { createClient } from '@supabase/supabase-js';

// website/js/auth.js
// Supabase Client Setup
const SUPABASE_URL = 'https://mbqgibftcecrvzkzxylt.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_wzwyZfr1FGR2VfC4dDql4g_KSxaHwEm';

// Only initialize if keys are provided (to avoid immediate console errors)
window.sb = null;
if (SUPABASE_URL !== 'YOUR_SUPABASE_URL') {
    window.sb = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
}
